<template>
  <div class="body_page">
    <div class="body_page_logs">
      <div class="body_page_logs_icon">
        <img src="https://img.aixuejie.cn/extra/showclub/5_1603682434/5_爱学界_1603682439_ee1eaddfe346bebfead92d86e04147cb.png">
      </div>
      <div class="body_page_logs_main_icon">
        <img src="@/assets/image/axj_web/axj_web_body_icon.png">
      </div>
      <div class="body_page_logs_label">
        <label>新校园生态</label>
      </div>
    </div>
<!--    <div class="body_page_prod_info">-->
<!--      <div class="body_page_prod_item">-->
<!--        <div class="body_page_prod_item_top">-->
<!--          <div class="body_page_prod_item_top_icon">-->
<!--            <img src="@/assets/image/axj_web/axj_web_page/axj_web_page_zixun.png"/>-->
<!--          </div>-->
<!--          <div class="body_page_prod_item_top_label">-->
<!--            <label>资讯</label>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="body_page_prod_item_body">-->
<!--          <div class="body_page_prod_item_body_text">-->
<!--            <span>-->
<!--            海量校园资讯等你来！<br/> 在这里，您可以浏览感兴趣的校园资讯，还能进行简单互动。-->
<!--          </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="body_page_prod_item">-->
<!--        <div class="body_page_prod_item_top">-->
<!--          <div class="body_page_prod_item_top_icon">-->
<!--            <img src="@/assets/image/axj_web/axj_web_page/axj_web_page_kewai.png"/>-->
<!--          </div>-->
<!--          <div class="body_page_prod_item_top_label">-->
<!--            <label>课外</label>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="body_page_prod_item_body">-->
<!--          <div class="body_page_prod_item_body_text">-->
<!--            <span>-->
<!--            课外的天地，精彩有你！在这里，您可以晒新鲜趣事、报名参赛、分享读书体会。-->
<!--          </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="body_page_prod_item">-->
<!--        <div class="body_page_prod_item_top">-->
<!--          <div class="body_page_prod_item_top_icon">-->
<!--            <img src="@/assets/image/axj_web/axj_web_page/axj_web_page_zhushou.png"/>-->
<!--          </div>-->
<!--          <div class="body_page_prod_item_top_label">-->
<!--            <label>助手</label>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="body_page_prod_item_body">-->
<!--          <div class="body_page_prod_item_body_text">-->
<!--            <span>-->
<!--            学习科研我来助力！<br/>-->
<!--在这里，您可以记录课程信息，参与班级和课题组互动。-->
<!--          </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="body_page_prod_item">-->
<!--        <div class="body_page_prod_item_top">-->
<!--          <div class="body_page_prod_item_top_icon">-->
<!--            <img src="@/assets/image/axj_web/axj_web_page/axj_web_page_fuwu.png"/>-->
<!--          </div>-->
<!--          <div class="body_page_prod_item_top_label">-->
<!--            <label>服务</label>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="body_page_prod_item_body">-->
<!--          <div class="body_page_prod_item_body_text">-->
<!--            <span>-->
<!--            让工作生活更贴心！<br/>-->
<!--在这里，您可以发布闲置物品、浏览工作招聘、共享图书文献。-->
<!--          </span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "body_page"
}
</script>

<style scoped lang="scss">
.body_page{
  height: 100%;
  display: flex;
  align-items: center;
  flex-flow: column;
  .body_page_prod_info{
    flex: 1;
    display: flex;
    justify-content: center;
    .body_page_prod_item:not(:first-child){
      margin-left: 122.5px;
    }
    .body_page_prod_item{
      width: 226.5px;
     // background-color: #3a8ee6;
      //margin-left: 122.5px;
      height: 182px;
      display: flex;
      align-items: center;
      flex-flow: column;
      .body_page_prod_item_top{
        width: 90px;
        height: 33.6px;
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: normal;
        font-size: 18.75px;
        line-height: 36px;
        display: flex;
        letter-spacing: 0.165em;
        color: #FFFFFF;
        .body_page_prod_item_top_icon{
          flex: 1;
          height: 100%;
          img{
            height: 100%;
          }
        }
        .body_page_prod_item_top_label{
          flex: 2;
          display: flex;
          justify-content: center;
          text-align: center;
        }
      }
      .body_page_prod_item_body{
        display: flex;
        justify-content: center;
        align-items: center;
        .body_page_prod_item_body_text{
          width: 170.25px;
        }
        background: rgba(255, 255, 255, 0.1);
        border-radius: 17px;
        height: 134px;
        margin-top: 14.6px;
        width: 100%;
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;

        line-height: 26.25px;
        color: #FFFFFF;
      }
    }
  }
  .body_page_logs{
    flex: 1;
    justify-content: center;
    display: flex;
    flex-flow: column;
    width: 340.5px;
    align-items: center;
    .body_page_logs_icon{
      img{
        width: 121.5px;
        height: 116px;
      }
    }
    .body_page_logs_main_icon{
      margin-top: 26.25px;
      img{
        width: 106.5px;
        height: 26.3px;
      }
    }
    .body_page_logs_label{
      margin-top: 14.3px;
      label{
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: normal;
        font-size: 18.75px;
        line-height: 36px;
        letter-spacing: 0.605em;
        color: #FFFFFF;
      }
    }
  }
}


@media screen and(max-width: 1310px) and(max-height: 718px){
  .body_page{
    .body_page_logs{
      .body_page_logs_icon{
        img{
          width: 110.44px;
          height: 106.22px;
        }
      }
      .body_page_logs_main_icon{
        margin-top: 23.85px;
        img{
          width: 106.5px;
          height: 26.3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/component/web_body/component/body_page/index.vue